
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"30","height":"20","viewBox":"0 0 152 97","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('rect',{attrs:{"x":"0","y":"0","width":"152","height":"96.9651","rx":"6","fill":"#131735"}}),_c('path',{attrs:{"d":"M57.471 37.8963 L40.9874 74.0628 L24.5107 37.8963 H31.8093 L40.9874 58.526 L50.1781 37.8963 H57.471 Z","fill":"#6AE69E"}}),_c('path',{attrs:{"d":"M57.4705 22.1752 H24.5195 V28.5059 H57.4705 V22.1752 Z","fill":"#6AE69E"}}),_c('path',{attrs:{"d":"M104.243 22.1751 H97.553 V73.1792 H104.243 V22.1751 Z","fill":"#6AE69E"}}),_c('path',{attrs:{"d":"M121.816 37.8921\n       V28.5064\n       H115.126\n       V37.8921\n       H109.668\n       V44.2227\n       H115.126\n       V73.1786\n       H121.816\n       V44.2227\n       C121.816 44.2227 123.828 44.2227 124.34 44.2227\n       C125.855 44.2227 127.228 43.2887 127.9 41.8196\n       C128.191 41.1833 129.69 37.8921 129.69 37.8921\n       H121.816\n       Z","fill":"#6AE69E"}}),_c('path',{attrs:{"d":"M74.5959 37.5362\n       C64.9757 37.5362 57.1772 45.5913 57.1772 55.5289\n       C57.1772 65.4664 64.9757 73.5215 74.5959 73.5215\n       C84.216 73.5215 92.015 65.4664 92.015 55.5289\n       C92.015 45.5913 84.216 37.5362 74.5959 37.5362\n       Z\n       M74.5959 66.7655\n       C68.6215 66.7655 63.7797 61.7353 63.7797 55.5289\n       C63.7797 49.3224 68.6227 44.2922 74.5959 44.2922\n       C80.5703 44.2922 85.412 49.3224 85.412 55.5289\n       C85.412 61.7353 80.5692 66.7655 74.5959 66.7655\n       Z","fill":"#6AE69E"}})])
          )
        }
      }
    